import type { Address } from '~/types'

type State = {
  verifying: boolean
  originalAddress: Address | null | undefined
  verificationStatus: string | null | undefined
  changedFields: Array<string> | null | undefined
  suggestedAddress: Address | null | undefined
  isValid: boolean | null | undefined
  lastValidatedAt: string | null | undefined
  displayModal: boolean
}

type Action = {
  type:
    | 'verify_request_start'
    | 'verify_request_finish'
    | 'verify_failure'
    | 'verify_flow_finish'
  originalAddress?: Address | null | undefined
  verificationStatus?: string | null | undefined
  changedFields?: Array<string> | null | undefined
  suggestedAddress?: Address | null | undefined
  isValid?: boolean | null | undefined
  lastValidatedAt?: string | null | undefined
}

export function addressVerificationReducer(state: State, action: Action) {
  switch (action.type) {
    case 'verify_request_start': {
      return {
        ...state,
        verifying: true,
        originalAddress: action.originalAddress,
      }
    }

    case 'verify_request_finish': {
      return { ...state, verifying: false }
    }

    case 'verify_failure': {
      return {
        ...state,
        verificationStatus: action.verificationStatus,
        changedFields: action.changedFields,
        suggestedAddress: action.suggestedAddress,
        isValid: action.isValid,
        lastValidatedAt: action.lastValidatedAt,
        displayModal: true,
      }
    }

    case 'verify_flow_finish': {
      return {
        ...state,
        verifying: false,
        originalAddress: undefined,
        verificationStatus: undefined,
        changedFields: undefined,
        suggestedAddress: undefined,
        isValid: undefined,
        lastValidatedAt: undefined,
        displayModal: false,
      }
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}
